import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Router } from '@angular/router'
import { ServerUrlService } from 'src/app/services/server-url.service'

@Component({
    selector: 'app-drawer',
    imports: [CommonModule],
    templateUrl: './drawer.component.html',
    styleUrls: ['./drawer.component.scss'],
    standalone: true
})
export class DrawerComponent {
  @Input()
  open: boolean = false
  @Output()
  onClose = new EventEmitter<any>()

  links = [
    {
      icon: '/assets/icons/drawer_schedule.svg',
      name: 'Agenda',
      link: '/mobile/schedules',
    },
    {
      icon: '/assets/icons/drawer_patients.svg',
      name: 'Pacientes',
      link: '/mobile/patients',
    },
    {
      icon: '/assets/icons/drawer_patients.svg',
      name: 'Atendimento exames',
      link: '/mobile/worklist/technician',
    },
    {
      icon: '/assets/icons/copy.svg',
      name: 'Versão desktop',
      link: 'otimus',
    },
    {
      icon: '/assets/icons/chevron_left.svg',
      name: 'Sair',
      link: 'sair',
    },
  ]

  constructor(private router: Router, private serverUrlService: ServerUrlService) {}

  doClose() {
    this.onClose.emit()
  }

  navigate(route: string) {
    if (route === 'otimus') {
      fetch(`${this.serverUrlService.url}/global/var0008`).then((res) => {
        res.json().then((val) => {
          location.href = `${val.value}/servlet/app.agendas`
        })
      })
      return
    }
    if (route === 'sair') {
      fetch(`${this.serverUrlService.url}/global/var0008`).then((res) => {
        res.json().then((val) => {
          localStorage.clear()
          location.href = `${val.value}/servlet/app.redirecinonalink?sair`
        })
      })
      return
    }

    this.router.navigateByUrl(route)
    this.doClose()
  }
}
